import { useQuery } from '@tanstack/react-query';
import apis from '@api/api';

export interface PaginationState {
	currentPage: number;
	pageSize: number;
	sortBy: string;
	sortOrder: 'asc' | 'desc';
}

export const createPaginationState = (
	initialState: Partial<PaginationState> = {}
): PaginationState => ({
	currentPage: 1,
	pageSize: 12,
	sortBy: 'updatedAt',
	sortOrder: 'desc',
	...initialState,
});

export const updatePaginationState = (
	current: PaginationState,
	updates: Partial<PaginationState>
): PaginationState => ({
	...current,
	...updates,
});

export const resetPaginationPage = (
	state: PaginationState
): PaginationState => ({
	...state,
	currentPage: 1,
});

/**
 * Custom hook for fetching paginated projects
 */
export const useProjectsQuery = ({
	pagination,
	enabled = true,
}: {
	pagination: PaginationState;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['projects-paginated', pagination],
		queryFn: async () => {
			const response = await apis.getProjectsPaginated({
				page: pagination.currentPage,
				limit: pagination.pageSize,
				sortBy: pagination.sortBy,
				sortOrder: pagination.sortOrder,
			});
			return response.data;
		},
		enabled,
		staleTime: 1000 * 60 * 5, // 5 minutes
		retry: 2,
	});
};
